<div class="p-4 bg-white shadow-lg rounded-2xl h-full flex flex-col items-center">
  <div class="w-full flex-1 flex items-center justify-between">
    <div class="w-full flex flex-1 items-center justify-items-start gap-4">
      @if (loading()) {
        <div class="w-full pe-4">
          <p-skeleton class="mb-4" />
          <p-skeleton height="2rem" />
        </div>
      } @else {
        <div class="border-l-4 pl-4 border-background-dark">
          @if (descriptionLight()) {
            <div class="text-zinc-400 text-sm">{{ descriptionLight() }}</div>
          }
          @if (descriptionDark()) {
            <div class="text-zinc-900 text-sm">{{ descriptionDark() }}</div>
          }
          @if (content()) {
            <div class="text-[1.4rem] font-bold text-zinc-900">{{ content() }}</div>
          }
        </div>
      }
    </div>
    @if (loading()) {
      <p-skeleton shape="circle" size="4rem" />
    } @else {
      @if (icon()) {
        <div class="bg-background rounded-full flex items-center justify-items-center py-4 px-3">
          <i [class]="'text-3xl ' + icon()"></i>
        </div>
      }
    }
  </div>
  <div class="w-full flex items-center">
    @if (loading()) {
      <div class="w-full mt-4">
        <p-skeleton />
      </div>
    } @else {
      @if (footerLight()) {
        <div class="text-zinc-400 text-sm mt-4">{{ footerLight() }}</div>
      }
      @if (footerDark()) {
        <div class="text-zinc-900 text-sm mt-4">{{ footerDark() }}</div>
      }
    }
  </div>
</div>
